/*
 * @Autor: dc
 * @Date: 2022-02-18 10:59:03
 * @LastEditors: dc
 * @LastEditTime: 2022-02-28 10:09:12
 * @Description: vuex路由常量（必须定义后才能使用）
 */
/**
 * 定义类型常量
 * */

const GET_USER = 'GET_USER';
const SET_USER = 'SET_USER';
const REMOVE_USER = 'REMOVE_USER';

const GET_TABBAR_CONFIG = 'GET_TABBAR_CONFIG';
const REMOVE_TABBAR_CONFIG = 'REMOVE_TABBAR_CONFIG';
const SET_TABBAR_CONFIG = 'SET_TABBAR_CONFIG';


const GET_GAMEDATA = 'GET_GAMEDATA';
const SET_GAMEDATA = 'SET_GAMEDATA';
const REMOVE_GAMEDATA = 'REMOVE_GAMEDATA';

export default {
    GET_USER,
    REMOVE_USER,
    SET_USER,

    GET_TABBAR_CONFIG,
    REMOVE_TABBAR_CONFIG,
    SET_TABBAR_CONFIG,


    GET_GAMEDATA,
    REMOVE_GAMEDATA,
    SET_GAMEDATA
}



// WEBPACK FOOTER //
// ./src/store/types.js


// WEBPACK FOOTER //
// ./src/store/types.js